import { UPDATE_VENDOR_OPPORTUNITY } from './updateVendorOpportunity';
import { GET_VO_PROPOSALS_OPTIONS } from './getVOProposalsOptions';
import { UPDATE_CURRENT_STAGE } from './updateCurrentStage';
import { Q_GET_DEAL_INFO_FROM_EXTERNAL_DMS } from './getDealInfoFromExternalDms';

export const VOApi = {
  update: UPDATE_VENDOR_OPPORTUNITY,
  updateCurrentStage: UPDATE_CURRENT_STAGE,
  fetchProposalOptions: GET_VO_PROPOSALS_OPTIONS,
  getDealInfoFromExternalDms: Q_GET_DEAL_INFO_FROM_EXTERNAL_DMS,
};
